import { roundOffAndFormatNumberWithCurrency } from '../../../../utils/utils'

type SaveTaxBookingRowProps = {
  saveTaxAmount: number
  bookAmount: number
  taxLabel: string
  gainLossLabel: string
}

export function SaveTaxBookingRow({ saveTaxAmount, bookAmount, taxLabel, gainLossLabel }: SaveTaxBookingRowProps) {
  const saveTaxFormatted = roundOffAndFormatNumberWithCurrency(saveTaxAmount)
  const bookFormatted = roundOffAndFormatNumberWithCurrency(bookAmount)

  return (
    <div className="flex gap-2 pt-2 pl-0 items-center">
      <div className="w-[3px] h-[27px] opacity-30 shrink-0 rounded-[10px] bg-[#6A6E6E]" />
      <div className="flex flex-col text-[13px] font-[400] text-[#6A6E6E]">
        {saveTaxFormatted != null && (
          <span className="font-[500] text-[#6A6E6E]">
            Save {saveTaxFormatted} in {taxLabel}
          </span>
        )}
        <span className="text-[#8E9393] font-[400]">
          by booking <span>{bookFormatted}</span> {gainLossLabel}
        </span>
      </div>
    </div>
  )
}
